(function() {
    'use strict';

    angular
        .module('trakeyeApp')
        .controller('CustomSectionTypeAttributeDialogController', CustomSectionTypeAttributeDialogController);

    CustomSectionTypeAttributeDialogController.$inject = ['$timeout', '$scope', '$state','$stateParams', 'entity', 'CustomSectionTypeAttribute'];

    function CustomSectionTypeAttributeDialogController ($timeout, $scope, $state ,$stateParams, entity, CustomSectionTypeAttribute) {
        var vm = this;

        vm.customSectionTypeAttribute = entity;
        vm.clear = clear;
        vm.save = save;
       // vm.customsectiontypeattributevalues = CustomSectionTypeAttributeValue.query();
        
        vm.items = [ {
			value : ''
		} ];
        
        if (vm.customSectionTypeAttribute.customSectionTypeAttributeValues != null && vm.customSectionTypeAttribute.customSectionTypeAttributeValues.length != 0) {
			vm.items = vm.customSectionTypeAttribute.customSectionTypeAttributeValues;
		}
        vm.addmore = function() {
			vm.items.push({
				value : ''
			});
		};

		vm.remove = function(index) {
			vm.items.splice(index, 1);
		};

        $timeout(function (){
            angular.element('.form-group:eq(1)>input').focus();
        });

        function clear () {
            //$uibModalInstance.dismiss('cancel');
        }

        function save () {
            vm.isSaving = true;
            if  ( vm.customSectionTypeAttribute.id !== null) {
            	
            	 vm.customSectionTypeAttribute.customSectionTypeAttributeValues = [];
				for (var i = 0; i < vm.items.length; i++) {
					 vm.customSectionTypeAttribute.customSectionTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
                CustomSectionTypeAttribute.update(vm.customSectionTypeAttribute, onSaveSuccess, onSaveError);
            } else {
            	
            	
            	 vm.customSectionTypeAttribute.customSectionTypeAttributeValues = [];

				for (var i = 0; i < vm.items.length; i++) {
					 vm.customSectionTypeAttribute.customSectionTypeAttributeValues.push({
						"id" : vm.items[i].id,
						"value" : vm.items[i].value
					});

				}
				
                CustomSectionTypeAttribute.save(vm.customSectionTypeAttribute, onSaveSuccess, onSaveError);
            }
        }

        function onSaveSuccess (result) {
            $scope.$emit('trakeyeApp:customSectionTypeAttributeUpdate', result);
           // $uibModalInstance.close(result);
            vm.isSaving = false;
            $state.go('custom-section-type-attribute');
        }

        function onSaveError () {
            vm.isSaving = false;
        }


    }
})();
